<template>
         <transition name="fade">
    <div :id="thumbId()" :class="widthClass()" style="padding-bottom:0px;">
        
        <div class="avatar" :style="{display: display()}">
            <a :id="actor.pv_id" data-toggle="collapse" :href="anchorCollapseName()">
                <img :src="actor.pv_bild" class="thumb z-depth-1" :alt="name" style="min-width:164px;">
            </a>
        </div>
        
        <a data-toggle="collapse" :href="anchorCollapseName()">
            <h5 class="my-1 font-bold text-center heimanns-text-color" v-html="name"></h5> 
        </a>                       
                            
        <div class="text-center" v-show="showTriangle()" :style="{display: display()}">
            <img style="width:28px;"
                 src="./../assets/img/Triangle-PNG-Transparent-40x30.png">
        </div>
         
    </div>
         </transition>
</template>

<script>
    export default {
        props: {
            'collapseName': {
                type: String
            },
            'numberOfActorsPerLine' : {
                type: Number
            },
            'actor': {
                type: Object
            },
            'isSameActorFn': {
                type: Function
            }           
        },
        data() {
            return {
                
            }
        },
        computed: {
            name : function() {
                return this.actor.pv_vorname + '<br/>' + this.actor.pv_nachname;
            }
        }, 
        mounted() {
            $('#' + this.actor.pv_id).on("toggle.collapse", this.toggleCollapse);
        },
        methods: {
            thumbId() {
                return 'thumb_' + this.actor.pv_id;
            },
            toggleCollapse() {
                console.log(this.anchorCollapseName());
                $(this.anchorCollapseName()).collapse('toggle');
            },
            anchorCollapseName() {
                return '#' + this.collapseName;
            },
            widthClass() {
                return 'width-' + this.numberOfActorsPerLine;
            },
            display() {
                if(this.actor !== null) {
                    if (this.actor.pv_id < 0) {
                        return 'none';
                    } else {
                        return '';
                    }
                } else {
                    return 'none';
                }              
                
                if (this.actor.pv_id < 0) {
                    
                } else {
                    return '';
                }
            },
            showTriangle() {               
                if(this.actor !== null) {
                    if (this.actor.pv_id < 0) {
                        return false;
                    } else {
                        return this.isSameActorFn(this.actor.pv_id);
                    }
                } else {
                    return false;
                }              
            }
        }
    }
</script>

<style scoped>
    .width-1 {
        width: 100%;
    }
    .width-2 {
        width: 50%;
    }
    .width-3 {
        width: 33%;
    }
    .width-4 {
        width: 25%;
    }
    .width-5 {
        width: 20%;
    }

    .fade-enter {
        opacity: 0;     
    }
    .fade-enter-active {
        transition: opacity 2s;
    }
    .fade-leave-active {
        transition: opacity 0s;
        opacity: 0;
    }

    .slide-enter {
            opacity: 0;
    }
    .slide-enter-active {
        animation: slide-in 1s ease-out forwards;
        transition: opacity 1s;
    }
    .slide-leave-active {
        animation: slide-out 1s ease-out forwards;
        transition: opacity 1s;
        opacity: 0;
    }
    .slide-move {
        transition : transformation 1s;
    }

    @keyframes slide-in {
        from {
            transform: translateY(20px);
        }
        to {
            transform: translateY(0);
        }
    }
   @keyframes slide-out {
        from {
            transform: translateY(0px);
        }
        to {
            transform: translateY(20px);
        }
    }
    
</style>



// WEBPACK FOOTER //
// src/components/PeopleRowThumb.vue